<template>
  <div class="accordion footer-accordion">
    <div
      v-for="(section, index) in sections"
      :key="index"
      class="row"
      :class="{ open: openAccordion === index + 1 }"
    >
      <h2 class="h4" @click="toggleAccord(index + 1)">
        {{ section.title }}
        <button>
          <span v-if="openAccordion === index + 1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="2"
              viewBox="0 0 16 2"
              fill="none"
            >
              <rect x="16" width="2" height="16" transform="rotate(90 16 0)" fill="#FDDD00" />
            </svg>
          </span>
          <span v-else
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <rect x="7" width="2" height="16" fill="white" />
              <rect
                x="16"
                y="7"
                width="2"
                height="16"
                transform="rotate(90 16 7)"
                fill="white"
              /></svg
          ></span>
        </button>
      </h2>
      <component
        :is="section.contentType"
        v-if="section.contentType && openAccordion === index + 1"
      >
        <component :is="section.listType || 'ul'" v-if="section.items && section.items.length">
          <li v-for="(item, i) in section.items" :key="i">
            <a :href="item.link">{{ item.text }}</a>
          </li>
        </component>
        <div v-else v-html="section.content"></div>
      </component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      openAccordion: 0,
    };
  },

  methods: {
    toggleAccord(number) {
      if (this.openAccordion !== number) {
        this.openAccordion = number;
      } else {
        this.openAccordion = 0;
      }
    },
  },
};
</script>
